import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { Spin, Empty } from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewQlRichText',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as {
  content?: string
};

/** 回显 Quill 的富文本内容 */


const loading = computed(() => {
  if (props.content === undefined) {
    return true
  }
  return false
})

return { __sfc: true,props, loading, Spin, Empty }
}

})